import { clientSide } from './dom.js';

/**
 * Sets custom attributes for enabled logging services
 * @param attributes array of attributes to be set
 * @param initialize only for New Relic, if true, will not call window.newrelic.interaction().save()
 */
var logCustomAttributes = function logCustomAttributes(attributes, initialize) {
  if (clientSide && window.newrelic) {
    attributes.forEach(function (_ref) {
      var name = _ref.name,
        value = _ref.value;
      window.newrelic.setCustomAttribute(name, value);
    });
    if (!initialize) window.newrelic.interaction().save();
  }
};

/**
 * Fires error event for enabled logging services
 * @param error the error to be logged
 */
var logError = function logError(error) {
  if (clientSide && window.newrelic) {
    window.newrelic.noticeError(error);
  }
};

/**
 * Sets the current route name and saves the interaction
 * @param route the name of the route
 */
var logCurrentRoute = function logCurrentRoute(route) {
  if (clientSide && window.newrelic) {
    window.newrelic.setCurrentRouteName(route);
    window.newrelic.interaction().save();
  }
};

/**
 * Sets the release name and version for the enabled logging services
 * @param name of the release
 * @param id of the release
 */
var logRelease = function logRelease(name, id) {
  if (clientSide && window.newrelic) {
    window.newrelic.addRelease(name, id);
  }
};

/**
 * Fires a custom event for enabled logging services
 * @param name event name
 * @param attributes associated with the event
 */
var logEvent = function logEvent(name) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (clientSide && window.newrelic) {
    window.newrelic.addPageAction(name, attributes);
    window.newrelic.interaction().save();
  }
};

export { logCurrentRoute, logCustomAttributes, logError, logEvent, logRelease };
